<template>
  <div class="index">
    <div class="index-content">
      <div class="exhibition-bg">
        <img src="@this/assets/image-02.jpg" />
        <img v-auth:click="gotoGame" src="@this/assets/image-01.png" class="exhibition-park" />
        <img @click="gotoRule" src="@this/assets/image-03.png" class="exhibition-rule" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { NScroll } from '@this/utils/scroll';
export default {
  data() {
    return {
      pavilionScroll: null,
    };
  },
  methods: {
    ...mapActions('goto', ['gotoGame', 'gotoRule']),
    initPavilionScroll() {
      this.$nextTick(() => {
        if (!this.pavilionScroll) {
          this.pavilionScroll = new NScroll({
            dom: '.index',
            options: {
              click: true,
              probeType: 3,
              observeDOM: true,
              bounce: false,
            },
            other: {
              center: true,
            },
          });
        }
      });
    },
  },
  created() {
    this.initPavilionScroll();
  },
  beforeDestroy() {
    this.pavilionScroll?.destroyNormalScroll();
  },
};
</script>
<style lang="scss" scoped>
.index {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #ffdecb;
  .index-content {
    display: table;
    margin: auto;
    position: relative;
    z-index: 1;
    .exhibition-bg {
      height: 750px;
      position: relative;
      img {
        width: 1496px;
      }
      .exhibition-park {
        position: absolute;
        top: 602px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 471px;
        height: 125px;
      }
      .exhibition-rule {
        position: absolute;
        width: 178px;
        height: 54px;
        top: 635px;
        right: 220px;
      }
    }
  }
}
</style>
